// Module
var code = "<ul> <li>Your bill will also include the repayment term of your loan based on your current repayment schedule.</li> </ul> ";
// Exports
export default code;